import React from "react";
import SvgIcon from "../../../parts/SvgIcon";
import { useTranslation } from "react-i18next";
/**
 *
 filters is an array like this:
 filters= [
  {
    text: '',
    id:....,
  },
  ...
 ]
 */
// FilterChips is shared by several unrelated filter/selection UIs; only
// callers that opt in with overflowLimit + openFilterModal get the collapsed
// "+N more" chip below. Without them every chip renders, same as before.
const FilterChips = ({
  filters,
  clearAllFilters,
  clearFilter,
  overflowLimit = Number.POSITIVE_INFINITY,
  openFilterModal,
}) => {
  const { t } = useTranslation("athlete-portal");
  const visibleFilters = filters.slice(0, overflowLimit);
  const overflowCount = filters.length - visibleFilters.length;

  return (
    <div className="filters-wrapper">
      {visibleFilters.map((filter) => (
        <div className="filter-item" key={filter.id}>
          {filter.text}{" "}
          <SvgIcon
            src={"/img/new-icons/red-cross-20px.svg"}
            onClickFn={() => clearFilter(filter.id)}
            noFilterOnLight={true}
          />
        </div>
      ))}
      {overflowCount > 0 && (
        <button
          type="button"
          className="filter-item filter-overflow-chip"
          onClick={openFilterModal}
        >
          {t("filterChips.overflow", { count: overflowCount })}
        </button>
      )}
      {clearAllFilters && filters.length > 0 && (
        <button data-button-type="secondary" data-action="cancel">
          {t("filterChips.clearAll")}
          <SvgIcon
            src={"/img/new-icons/red-cross-20px.svg"}
            onClickFn={clearAllFilters}
            noFilterOnLight={true}
          />
        </button>
      )}
    </div>
  );
};

export default FilterChips;
